
import { makeAutoObservable } from 'mobx';
import {
  get_symbolStar,
  post_symbolStar,
  delete_symbolStarId,
  post_symbolStar_edit,
} from '@/api/v4/account';
import {get_fapiCollectionList} from "@/api/futures";

function normalizeSymbolStarList(raw: unknown): string[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object' && 'symbol' in (item as object)) {
          const s = (item as { symbol?: unknown }).symbol;
          return typeof s === 'string' ? s : '';
        }
        return '';
      })
      .filter(Boolean);
  }
  if (typeof raw === 'object' && raw !== null) {
    const o = raw as Record<string, unknown>;
    if ('result' in o) return normalizeSymbolStarList(o.result);
    if ('data' in o) return normalizeSymbolStarList(o.data);
    if (Array.isArray(o.list)) return normalizeSymbolStarList(o.list);
    if (Array.isArray(o.items)) return normalizeSymbolStarList(o.items);
    if (typeof o.symbols === 'string' && o.symbols.trim() !== '') {
      return o.symbols.split(',').map((s) => String(s).trim()).filter(Boolean);
    }
  }
  return [];
}

export default class Market {

  loginStatus: number=0;
  userMarket: string[] = [];
  userContractMarket: [] = [];
  

  constructor() {
    makeAutoObservable(this);
  }

  init(appState){
    this.userMarket = [];
  }

  setLoginStatus(loginStatus: number){
    this.loginStatus = loginStatus;
    if (loginStatus !== 1) {
      this.userMarket = [];
    }
  }

  /**
   * 自选列表：登录后从接口拉取；未登录为空。
   */
  async getUserMarket() {
    if (this.loginStatus !== 1) {
      this.userMarket = [];
      return this.userMarket;
    }
    try {
      const raw = await get_symbolStar();
      this.userMarket = normalizeSymbolStarList(raw);
    } catch {
      this.userMarket = [];
    }
    return this.userMarket;
  }

  /** 添加收藏 */
  async addUserMarket(symbol: string) {
    if (!symbol || this.loginStatus !== 1) return;
    try {
      await post_symbolStar({ params: { symbol } });
      await this.getUserMarket();
    } catch {
      await this.getUserMarket();
    }
  }

  /** 取消收藏 */
  async removeUserMarket(symbol: string) {
    if (!symbol || this.loginStatus !== 1) return;
    try {
      await delete_symbolStarId(symbol);
      await this.getUserMarket();
    } catch {
      await this.getUserMarket();
    }
  }

  /** 批量覆盖收藏顺序（编辑页 Done / 置顶 / 推荐批量添加） */
  async setUserMarket(list: string[]) {
    if (this.loginStatus !== 1) return;
    const unique = Array.from(new Set((list || []).filter((s) => typeof s === 'string')));
    try {
      await post_symbolStar_edit({ symbols: unique.join(',') });
      await this.getUserMarket();
    } catch {
      await this.getUserMarket();
    }
  }

  /**
   * 置顶：将 symbol 移到有序列表第一位
   */
  async pinUserMarket(symbol: string) {
    if (!symbol || this.loginStatus !== 1) return;
    const current = Array.isArray(this.userMarket) ? this.userMarket : [];
    if (!current.includes(symbol)) return;
    const next = [symbol, ...current.filter((s) => s !== symbol)];
    await this.setUserMarket(next);
  }

  async getUserContractMarket() {
    if(this.loginStatus != 1)return;
    const data = await get_fapiCollectionList({ isReturnResponse: true });
    if(data && data.data && data.data.result)
      this.userContractMarket = data.data.result;
  }
}
